import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  notificationClear,
  notificationFail,
  notificationSuccess,
} from "../slices/notificationSlice";
import { setAutherise } from "../slices/commonSlice";
import { userAuthDetails } from "./authThunk";
import { Auth, Amplify } from "aws-amplify";
import { API, graphqlOperation } from "aws-amplify";
import { addLogsAws } from "../../graphql/mutations";
import { RootState } from "../store";
import { updateTenantInfoThunk } from "./tenantThunk";
import GrafanaClient from "../../config/grafanaClient";

export const cleatNotification = createAsyncThunk(
  "cleatNotification",
  async (_request: any, { dispatch }) => {
    dispatch(notificationClear());
  }
);

export const setLoginwithtype = createAsyncThunk(
  "setLoginwith",
  async (_request: any, { dispatch }) => {
    localStorage.setItem("loginwith", _request);
  }
);
export const setTenantId = createAsyncThunk("setTenantId", async (_request: any, { dispatch, getState }) => {
  localStorage.setItem('tenantId', JSON.stringify(_request))
  localStorage.removeItem('overview')
  localStorage.removeItem('query')
  localStorage.removeItem('threshold')
  localStorage.removeItem('downloaddashboard')
  localStorage.removeItem('onLoadOverview')
  localStorage.removeItem('default_facility_location')
  const userData = (getState() as RootState).authReducer?.userData;
  if(_request.tenantId !== "0000"){
    dispatch(
      updateTenantInfoThunk({
        tenant_info: JSON.stringify(_request),
        username: userData?.username,
        user: userData,
      })
    );
  } 
});

export const setForSummaryPage = createAsyncThunk(
  "setForSummaryPage",
  async (_request: any, { dispatch }) => {
    localStorage.setItem("summary", JSON.stringify(_request));
  }
);

export const checkAuth = createAsyncThunk(
  "checkAuth",
  async (_request: any, { dispatch }) => {
    Auth.currentAuthenticatedUser()
      .then(async (user: any) => {
        dispatch(userAuthDetails({ user: user, email: true }));
        dispatch(setAutherise(true));
      })
      .catch((err) => {
        dispatch(setAutherise(false));
      });
  }
);

export const ChangeServiceRequest = createAsyncThunk(
  "changeservice",
  async (_request: any, { dispatch }) => {
    Amplify.configure(_request.request);
  }
);

export const addLogToAws = createAsyncThunk(
  "addLogToAws",
  async (_request: any, { dispatch }) => {
    const list = (await API.graphql({
      ...graphqlOperation(addLogsAws, { addLogs: _request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; errors: any[] };
  }
);

export const sendMagicLink = createAsyncThunk(
  "sendMagicLink",
  async (_request: any, { dispatch }) => {
    try {
      const response = await GrafanaClient().post(
        `/sso-login/sent-link`,
        {
          email: _request.email,
        }
      );
      dispatch(notificationSuccess("Magic link sent successfully"));
      return response?.data;
    } catch (err) {
      dispatch(notificationFail("Failed to send magic link"));
    }
  }
);
